import ApplicationController from '../application_controller'

class MoveToEmployeeController extends ApplicationController {
  static targets = ['position', 'units', 'template']

  connect () {
    this._bindChangeEvents()
    this._bindUnitId(this.positionTarget)

    $(this.positionTarget).on('change', (e) => { this._bindUnitId(e.target) })
  }

  _bindChangeEvents () {
    const changeEvent = new Event('change')
    this.hasUnitsTarget && this.unitsTarget.dispatchEvent(changeEvent)
    this.hasTemplateTarget && this.templateTarget.dispatchEvent(changeEvent)
  }

  _bindUnitId (target) {
    const unitId = $(target).find(':selected').data('unit-id')

    if (unitId) {
      this.unitsTarget.value = unitId
      this._bindChangeEvents()
    }
  }
}

export default MoveToEmployeeController
